import OwnerEntityNotes from './OwnerEntityNotes';

export default OwnerEntityNotes;
